import React from "react";
import { Container, Toolbar, AppBar } from "@mui/material";
import { Copyright } from "@mui/icons-material";

export default function Footer() {
  return (
    <AppBar
      position="static"
      style={{ backgroundColor: "#E4E5E6", marginTop: "auto" }}
    >
      <Container style={{ marginLeft: 35 }}>
        <Toolbar>
          <p style={{ color: "#77787B", marginTop: 15 }}>
            <Copyright /> 2021-2024 FinSoftAI Solutions, All Rights Reserved.
          </p>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
